import { Auth } from '@/services/auth-service'
import { Button, Icon, Menu, MenuItem } from '@tempots/beatui'
import { attr, Ensure, html, Signal, Use } from '@tempots/dom'
import { Location } from '@tempots/ui'

export interface UserMenuOptions {
  agencyId: Signal<string>
}

export function UserMenu({ agencyId }: UserMenuOptions) {
  const user = Auth.user
  return Use(Location, location => {
    return html.div(
      attr.class('flex flex-col items-center'),
      Ensure(
        user,
        user =>
          Button(
            {
              variant: 'filled',
              color: 'primary',
            },
            html.div(
              attr.class('flex flex-row items-center gap-1 sm:gap-2'),
              Icon({ icon: 'line-md:account', color: 'white' }),
              html.div(
                attr.class('hidden sm:block'),
                user.$.fullName.map(n => n ?? 'Unknown User')
              )
            ),
            Menu({
              placement: 'bottom-end',
              items: () => [
                MenuItem({
                  before: Icon({
                    icon: 'duo-icons:credit-card',
                    color: 'gray',
                  }),
                  onClick: () =>
                    location.navigate(`/${agencyId.value}/billing`),
                  content: 'Plans & Billing',
                }),
                MenuItem({
                  before: Icon({
                    icon: 'line-md:account',
                    color: 'gray',
                  }),
                  onClick: () =>
                    location.navigate(`/${agencyId.value}/profile`),
                  content: 'Profile',
                }),
                MenuItem({
                  before: Icon({
                    icon: 'line-md:question-circle',
                    color: 'gray',
                  }),
                  onClick: () => location.navigate('/faq'),
                  content: 'Help & Support',
                }),
                MenuItem({
                  before: Icon({
                    icon: 'line-md:logout',
                    color: 'gray',
                  }),
                  onClick: () => {
                    Auth.signout()
                    location.navigate('/')
                  },
                  content: 'Sign Out',
                }),
              ],
            })
          ),
        () => html.div('User not logged in')
      )
    )
  })
}
